import { render } from "./HexopayGooglePay.vue?vue&type=template&id=e28d83b4"
import script from "./HexopayGooglePay.vue?vue&type=script&lang=js"
export * from "./HexopayGooglePay.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__